export default __webpack_public_path__ + "static/media/upi.23aa93c4.jpg";